module.exports = __webpack_public_path__ + "4d568d06333864a7252414962cb1cb39.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special-conditions/anticuagulado.png
// module id = 282
// module chunks = 0